import { appStorage } from './betaStorage'
export type OnboardingCategory = 'Required reading' | 'Training video' | 'Safety & support'

export interface OnboardingRequirement {
  id: string
  title: string
  description: string
  category: OnboardingCategory
}

export interface WorkerOnboardingRecord {
  userId: string
  completedItemIds: string[]
  acknowledged: boolean
  signedName: string
  completedAt?: string
  updatedAt: string
}

export const ONBOARDING_REQUIREMENTS: OnboardingRequirement[] = [
  { id: 'about-me', title: 'About Me', description: 'Participant preferences, communication and daily life.', category: 'Required reading' },
  { id: 'behaviour-support', title: 'Behaviour Support Plan', description: 'Current plan and agreed support strategies.', category: 'Required reading' },
  { id: 'communication-guide', title: 'Communication Guide', description: 'How the participant communicates and makes choices.', category: 'Required reading' },
  { id: 'emergency-info', title: 'Emergency & Safety Information', description: 'Emergency contacts, risks, allergies and important safety information.', category: 'Safety & support' },
  { id: 'transfers', title: 'Transfers & Manual Handling', description: 'Participant-specific transfer and manual handling demonstrations.', category: 'Training video' },
  { id: 'equipment', title: 'Equipment Use', description: 'Instructions for equipment used when providing support.', category: 'Training video' },
  { id: 'routines', title: 'Daily Routines', description: 'Important routines, preferences and support instructions.', category: 'Safety & support' },
]

const STORAGE_KEY = 'schub.onboarding.v1'

export function emptyOnboardingRecord(userId: string): WorkerOnboardingRecord {
  return { userId, completedItemIds: [], acknowledged: false, signedName: '', updatedAt: new Date().toISOString() }
}

export function loadOnboardingRecords(): WorkerOnboardingRecord[] {
  try {
    const raw = appStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function getOnboardingRecord(userId: string): WorkerOnboardingRecord {
  return loadOnboardingRecords().find((record) => record.userId === userId) ?? emptyOnboardingRecord(userId)
}

export function saveOnboardingRecord(record: WorkerOnboardingRecord): WorkerOnboardingRecord {
  const records = loadOnboardingRecords().filter((item) => item.userId !== record.userId)
  const next = { ...record, updatedAt: new Date().toISOString() }
  appStorage.setItem(STORAGE_KEY, JSON.stringify([...records, next]))
  window.dispatchEvent(new Event('schub-onboarding-updated'))
  return next
}

export function onboardingProgress(record: WorkerOnboardingRecord): number {
  if (!ONBOARDING_REQUIREMENTS.length) return 0
  const completed = ONBOARDING_REQUIREMENTS.filter((item) => record.completedItemIds.includes(item.id)).length
  return Math.round((completed / ONBOARDING_REQUIREMENTS.length) * 100)
}

